export default {
  methods: {
    showTrackBtn (order) {
      if (order.order_data && ['web', 'app'].includes(this.$platform)) {
        return !['delivered', 'out_of_coverage', 'double_order', 'shop_closing', 'bad_weather', 'refunded', 'refund', 'canceled'].includes(order.status)
      }
      return false
    },
    trackOrder (order) {
      this.setCurrentOrder(order)
      this.redirectToTracker()
    }
  }
}